import actions from '@/store/modules/campaign/actions'
import getters from '@/store/modules/campaign/getters'
import mutations from '@/store/modules/campaign/mutations'
import state from '@/store/modules/campaign/state'

export default {
    actions,
    getters,
    mutations,
    state
}